import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "vendor-schedule-page" }
const _hoisted_2 = { class: "vendor-schedule-page__content" }
const _hoisted_3 = { class: "vendor-schedule-page__header" }
const _hoisted_4 = { class: "vendor-schedule-page__header-icon" }
const _hoisted_5 = { class: "vendor-schedule-page__benefit" }
const _hoisted_6 = { class: "vendor-schedule-page__benefit" }
const _hoisted_7 = { class: "vendor-schedule-page__actions px-2 mb-10" }
const _hoisted_8 = {
  key: 0,
  class: "vendor-schedule-page__submit-error"
}

import { computed, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import AppTextField from "@/shared/components/ui/AppTextField.vue";
import AppAddressField from "@/shared/components/ui/AppAddressField.vue";
import AppDateField from "@/shared/components/ui/AppDateField.vue";
import AppTimeField from "@/shared/components/ui/AppTimeField.vue";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import AppMobileField from "@/shared/components/ui/AppMobileField.vue";
import { sendDemoRequest } from "@/shared/services/demo-requests.api";

type HoaAddressSelection = {
  id: number;
  number: string;
  street: string;
  unit: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  latitude: string;
  longitude: string;
  full_address: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'VendorSchedulePage',
  setup(__props) {

const form = reactive({
  name: "",
  phone: "",
  email: "",
  hoaAddress: "",
  demoDate: null as Date | string | null,
  demoTime: "",
  addressRaw: null as HoaAddressSelection | null,
});

const errors = reactive({
  name: "",
  phone: "",
  email: "",
  hoaAddress: "",
  demoDate: "",
  demoTime: "",
});

const isSubmitting = ref(false);
const submitError = ref("");
const router = useRouter();

const tomorrow = computed(() => {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  date.setHours(0, 0, 0, 0);
  return date;
});

const required = (v: unknown) => Boolean(String(v ?? "").trim()) || "Required";
const email = (v: unknown) => /.+@.+\..+/.test(String(v ?? "").trim()) || "Invalid email";
const phone = (v: unknown) => Boolean(String(v ?? "").trim()) || "Invalid phone";

function handleHoaAddressSelected(address: HoaAddressSelection | null) {
  form.addressRaw = address;
  console.log("Selected HOA address:", address);
}

async function handleSubmit() {
  submitError.value = "";

  errors.name = form.name.trim() ? "" : "Required";
  errors.phone = form.phone.trim() ? "" : "Required";
  errors.email = form.email.trim() ? "" : "Required";
  errors.hoaAddress = form.hoaAddress.trim() ? "" : "Required";
  errors.demoDate = form.demoDate ? "" : "Required";
  errors.demoTime = form.demoTime.trim() ? "" : "Required";

  if (Object.values(errors).some(Boolean)) return;

  isSubmitting.value = true;
  try {
    await sendDemoRequest({
      name: form.name.trim(),
      phone: form.phone.trim(),
      email: form.email.trim(),
      hoa_address: form.hoaAddress.trim(),
      address_data: form.addressRaw,
      demo_date: formatDemoDate(form.demoDate),
      demo_time: form.demoTime.trim(),
    });

    await router.push({ name: "vendor.schedule.success" });
  } catch (error) {
    submitError.value = "Unable to submit your request. Please try again.";
    console.error("[vendor-schedule] demo request failed", error);
  } finally {
    isSubmitting.value = false;
  }
}

function formatDemoDate(value: Date | string | null) {
  if (!value) return "";
  if (typeof value === "string") return value;

  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { class: "vendor-schedule-page__container" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "primary"
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("mdi-calendar-clock-outline", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "vendor-schedule-page__title mb-2 ma-0" }, "Schedule a Demo", -1)),
            _cache[18] || (_cache[18] = _createElementVNode("p", { class: "vendor-schedule-page__subtitle vendor-schedule-page__subtitle--lead" }, " Book your personalized demo. ", -1)),
            _cache[19] || (_cache[19] = _createElementVNode("p", { class: "vendor-schedule-page__subtitle" }, " See how we connect your HOA with trusted vendors. Pick a time that works. Our team will confirm within one business day. ", -1)),
            _createVNode(_component_v_row, {
              class: "vendor-schedule-page__benefits",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  class: "vendor-schedule-page__benefit-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_icon, {
                        size: "24",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode("mdi-clock-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[14] || (_cache[14] = _createElementVNode("span", null, "30 minutes", -1))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  class: "vendor-schedule-page__benefit-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_v_icon, {
                        size: "24",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("mdi-video-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[16] || (_cache[16] = _createElementVNode("span", null, "Live demo", -1))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_v_form, {
            class: "vendor-schedule-page__form",
            onSubmit: _withModifiers(handleSubmit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "vendor-schedule-page__row",
                dense: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppTextField, {
                        modelValue: form.name,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
                          _cache[1] || (_cache[1] = ($event: any) => (errors.name = ''))
                        ],
                        label: "Your Full Name",
                        "label-icon": "mdi-account-outline",
                        placeholder: "John Smith",
                        rules: [required],
                        autocomplete: "name",
                        "error-messages": errors.name ? [errors.name] : []
                      }, null, 8, ["modelValue", "rules", "error-messages"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppTextField, {
                        modelValue: form.email,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((form.email) = $event)),
                          _cache[3] || (_cache[3] = ($event: any) => (errors.email = ''))
                        ],
                        label: "Email Address",
                        "label-icon": "mdi-email-outline",
                        placeholder: "john@example.com",
                        rules: [required, email],
                        autocomplete: "email",
                        "error-messages": errors.email ? [errors.email] : []
                      }, null, 8, ["modelValue", "rules", "error-messages"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(AppMobileField, {
                          modelValue: form.phone,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => ((form.phone) = $event)),
                            _cache[5] || (_cache[5] = ($event: any) => (errors.phone = ''))
                          ],
                          label: "Phone Number",
                          "label-icon": "mdi-phone-outline",
                          placeholder: "555 123 4567",
                          rules: [required, phone],
                          autocomplete: "tel",
                          "error-messages": errors.phone ? [errors.phone] : []
                        }, null, 8, ["modelValue", "rules", "error-messages"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppAddressField, {
                        modelValue: form.hoaAddress,
                        "onUpdate:modelValue": [
                          _cache[6] || (_cache[6] = ($event: any) => ((form.hoaAddress) = $event)),
                          _cache[7] || (_cache[7] = ($event: any) => (errors.hoaAddress = ''))
                        ],
                        label: "HOA Address",
                        "label-icon": "mdi-map-marker-outline",
                        placeholder: "123 Maple St, Springfield",
                        "prepend-inner-icon": "",
                        rules: [required],
                        autocomplete: "street-address",
                        "error-messages": errors.hoaAddress ? [errors.hoaAddress] : [],
                        onSelected: handleHoaAddressSelected
                      }, null, 8, ["modelValue", "rules", "error-messages"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppDateField, {
                        modelValue: form.demoDate,
                        "onUpdate:modelValue": [
                          _cache[8] || (_cache[8] = ($event: any) => ((form.demoDate) = $event)),
                          _cache[9] || (_cache[9] = ($event: any) => (errors.demoDate = ''))
                        ],
                        label: "Preferred Date",
                        "label-icon": "mdi-calendar-outline",
                        placeholder: "Jun 24, 2026",
                        "min-date": tomorrow.value,
                        rules: [required],
                        "error-messages": errors.demoDate ? [errors.demoDate] : []
                      }, null, 8, ["modelValue", "min-date", "rules", "error-messages"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppTimeField, {
                        modelValue: form.demoTime,
                        "onUpdate:modelValue": [
                          _cache[10] || (_cache[10] = ($event: any) => ((form.demoTime) = $event)),
                          _cache[11] || (_cache[11] = ($event: any) => (errors.demoTime = ''))
                        ],
                        label: "Preferred Time",
                        "label-icon": "mdi-clock-outline",
                        placeholder: "10:30 AM",
                        rules: [required],
                        "error-messages": errors.demoTime ? [errors.demoTime] : []
                      }, null, 8, ["modelValue", "rules", "error-messages"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(AppButtonFlat, {
                  color: "primary",
                  block: "",
                  type: "submit",
                  "prepend-icon": "mdi-calendar",
                  loading: isSubmitting.value,
                  disabled: isSubmitting.value
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode(" Request Demo ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              (submitError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(submitError.value), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})